import type { PublicTenant } from '@/lib/api/schemas';
import { isoWeekday, todayIn, WEEKDAY_NAMES } from '@/lib/time';

export function hoursForDay(t: PublicTenant, day: string): { opens: string; closes: string }[] {
  const ex = t.exceptions.find((e) => e.day === day);
  if (ex) return ex.is_closed || !ex.opens || !ex.closes ? [] : [{ opens: ex.opens, closes: ex.closes }];
  const wd = isoWeekday(day);
  return t.hours.filter((h) => h.weekday === wd).map((h) => ({ opens: h.opens, closes: h.closes }));
}

export function todayHoursLabel(t: PublicTenant): string {
  const list = hoursForDay(t, todayIn(t.timezone));
  if (list.length === 0) return 'Сегодня выходной';
  return `Сегодня ${list.map((h) => `${h.opens}–${h.closes}`).join(', ')}`;
}

/** Сводка недели: соседние дни с одинаковыми часами объединяются (Пн–Пт 09:00–20:00) */
export function weekSummary(t: PublicTenant): { days: string; hours: string }[] {
  const per = [1, 2, 3, 4, 5, 6, 7].map((wd) => {
    const h = t.hours.filter((x) => x.weekday === wd);
    return h.length ? h.map((x) => `${x.opens}–${x.closes}`).join(', ') : 'выходной';
  });
  const out: { days: string; hours: string }[] = [];
  let start = 0;
  for (let i = 1; i <= 7; i++) {
    if (i === 7 || per[i] !== per[start]) {
      const a = WEEKDAY_NAMES[start]!;
      const b = WEEKDAY_NAMES[i - 1]!;
      out.push({ days: start === i - 1 ? a : `${a}–${b}`, hours: per[start]! });
      start = i;
    }
  }
  return out;
}
